import { View } from "react-native";
import SettingsCard from "../common/settings-card";
import OrderingHours from "./ordering-hours";
import Schedule from "./schedule";
import TemporaryClosure from "./temporary-closure";
import { memo } from "react";

const ScheduleSettings = () => {
  return (
    <View className="flex-1 w-full gap-4">
      <SettingsCard title="Hours" noSpacing>
        <TemporaryClosure />
        <Schedule />
        <OrderingHours />
      </SettingsCard>
    </View>
  );
};

export default memo(ScheduleSettings);
